import { call, put } from 'redux-saga/effects';
import isJwtFormat from '@oup/shared-node-browser/isJwtFormat.js';
import { accessTaskFailed, accessTaskSuccess } from '../../../../actions/userTaskActions.js';
import getUserDetailsFromUserToken from '../../../utils/getUserDetailsFromUserToken.js';
import setUserTaskInStorage from '../../../utils/setUserTaskInStorage.js';

/**
 * Validate and extract the token from the URL.
 */
const extractTokenFromPathname = pathname => {
  const pathNameParts = pathname.replace(/^\/|\/$/g, '').split('/');
  if (pathNameParts[0] === 'myTasks' && isJwtFormat(pathNameParts[1])) {
    return pathNameParts[1];
  }
  return null;
};

/**
 * Access task (e.g. placement test) to store the user token data in the session storage.
 * The session storage data is necessary to let the system automatically accept the invite and
 * redirect the user to the task URL.
 * This process usually starts when the user clicks on a link in an org invitation notification.
 * The URL is in the format /myTasks/{userToken}.
 * The user may or may not be authenticated when accessing the task URL, which is why it is called before user auth.
 */
export default function* accessTask(action) {
  try {
    const { pathname } = action.payload;
    const token = extractTokenFromPathname(pathname);

    if (!token) {
      // If the URL is not in the expected format
      yield put(accessTaskFailed('Access user task: invalid URL format'));
      return;
    }

    const userDetailsFromToken = yield call(getUserDetailsFromUserToken, token);
    const tokenData = userDetailsFromToken?.tokenData || {};
    const userId = tokenData?.userId;

    if (!userId) {
      yield put(accessTaskFailed('Invalid token or missing userId'));
      return;
    }

    yield call(setUserTaskInStorage, tokenData);
    yield put(accessTaskSuccess(tokenData));
  } catch (error) {
    console.log('Error in accessTask', error);
    yield put(accessTaskFailed(error.message));
  }
}
